import Raven from 'raven-js';
export const captureMessage = (msg, options) => Raven.captureMessage(msg, Object.assign({
  stacktrace: true
}, options));
const getExtraContextFromError = ex => {
  // responseJSON is a key on errors produced by hub-http
  if ('responseJSON' in ex) {
    return {
      status: ex.status,
      errorMessage: ex.errorMessage,
      response: ex.responseJSON,
      data: ex.data,
      location: 'getExtraContextFromError'
    };
  }
  return null;
};
export const captureException = (error, options = {}) => {
  const extraData = getExtraContextFromError(error);
  if (extraData) {
    options.extra = Object.assign({}, extraData, options.extra || {});
  }
  Raven.captureException(error, Object.assign({
    stacktrace: true
  }, options));
};